import React, { useMemo } from "react";
import "./dashboard-second-block.component.scoped.scss";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@material-ui/core";
import DashboardTableCard from "../dashboard-table-card/dashboard-table-card.component";
import { LocalStorageService } from "../../../../services/local-storage/local-storage";

export default function DashboardSecondBlock(props: any) {
  const { t } = useTranslation();
  const { user, cases } = props;
  const localStorage = useMemo(() => new LocalStorageService(), []);

  return (
    <Box className="cards__content mb-5">
      <Box
        className="dashboard-card  global__box__content"
        style={{ height: "fit-content" }}
      >
        <Box className="card-details">
          <Typography variant="h3">{t("ABOUT")}</Typography>
        </Box>
        <Box className="user-info">
          <Box className="item">
            <Typography variant="body1">{t("NAME")}:</Typography>
            <Typography variant="body1" className="text-capitalize">
              {user.firstName + " " + user.lastName}
            </Typography>
          </Box>
          <Box className="item">
            <Typography variant="body1">{t("WORKSPACE")}:</Typography>
            <Typography variant="body1">
              {localStorage.getData("tenantName")}
            </Typography>
          </Box>
          <Box className="item">
            <Typography variant="body1">{t("ROLE")}:</Typography>
            <Typography variant="body1">{t("ROLES." + user.role)}</Typography>
          </Box>
          <Box className="item">
            <Typography variant="body1">{t("COMPANY")}:</Typography>
            <Typography variant="body1">{user.company}</Typography>
          </Box>
          {user.telephone && (
            <Box className="item">
              <Typography variant="body1">{t("PHONE_NUMBER")}:</Typography>
              <Typography variant="body1">{user.telephone}</Typography>
            </Box>
          )}
          <Box className="item">
            <Typography variant="body1">{t("EMAIL")}:</Typography>
            <Typography variant="body1">{user.email}</Typography>
          </Box>
        </Box>
      </Box>
      {/* {statusChart && (
        <Box className="card__content">
          <DashboardGraphCard
            title={t("DASHBOARD.USECASE_STAGES")}
            subTitle={""}
            chart={statusChart.stages}
            type={"horizontalBar"}
          />
        </Box>
      )} */}
      {cases.data && (
        <Box className="card__content">
          <DashboardTableCard
            title={t(cases.title)}
            subTitle={t(cases.subTitle)}
            columns={cases.columns}
            tableName={cases.tableName}
            data={cases.data}
            clickableRow={true}
          />
        </Box>
      )}
    </Box>
  );
}
